import React from "react";
import StatusBadge from "@/components/StatusBadge";
import Actions from "./BaseTable/Actions";

export const columns = () => {
  return [
    {
      accessorKey: "actions",
      header: "Actions",
      enableResizing: false,
      enableSorting: false,
      cell: ({ row }) => <Actions row={row} />,
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
    {
      accessorKey: "user",
      header: "Username",
      cell: ({ row }) => <div>{row.original.user?.username ?? "-"}</div>,
    },
    {
      accessorKey: "sport.code",
      header: "Sport ID",
      cell: ({ row }) => <div>{row.original.sport?.code ?? "-"} </div>,
    },
    {
      accessorKey: "title",
      header: "Title",
    },
    {
      accessorKey: "created_at",
      header: "Date Posted",
    },
    {
      accessorKey: "language",
      header: "Language",
      cell: ({ row }) => (
        <div className="uppercase">
          {row.original.language?.code
            ? row.original.language?.code
            : row.original.language_type === "all"
            ? "All"
            : "All-EN"}
        </div>
      ),
    },
    {
      accessorKey: "source_platform",
      header: "Source Platform",
      cell: ({ row }) => <div>{row.original.source_platform?.name}</div>,
    },

    {
      accessorKey: "video_category",
      header: "Category",
      cell: ({ row }) => <div>{row.original.video_category?.name}</div>,
    },
    {
      accessorKey: "comments",
      header: "Comments",
    },
    {
      accessorKey: "react_totals",
      header: "React Total",
    },
    ...[...Array(5)].map((_, index) => ({
      accessorKey: `tag${index + 1}`,
      header: `Tag ${index + 1}`,
      cell: ({ row }) => {
        const tags = row.original.tags || [];
        const tag = tags[index];
        return <div>{tag ? tag.name : "-"}</div>;
      },
    })),
    {
      accessorKey: "total_likes",
      header: "Likes",
      cell: ({ row }) => <div>{row.original.likes?.total_likes || 0}</div>,
    },
    {
      accessorKey: "total_share",
      header: "Shares",
      cell: ({ row }) => <div>{row.original.shares?.total_shares || 0}</div>,
    },
    {
      accessorKey: "total_views",
      header: "Views",
      cell: ({ row }) => <div>{row.original.views?.total_views || 0}</div>,
    },
  ];
};
